export default "__VITE_PUBLIC_ASSET__08cf24ac__"